/** localStorage that never throws (private windows, blocked site data); UI preferences only. */
export const prefs = {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string) {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Preference just won't persist.
    }
  },
};

/** Keep in sync with the pre-paint script in index.html. */
export const THEME_KEY = 'cl-admin-theme';
export const SIDER_KEY = 'cl-admin-sider-collapsed';
